export const filterPresets = {
  all: {
    isShowAll: true,
    onlyMyConversations: false,
    isSpam: false,
    isInvalidContacts: false,
    isOptedOutContacts: false,
    isUnreadContacts: false,
  },
  unread: {
    isShowAll: true,
    onlyMyConversations: false,
    isSpam: false,
    isInvalidContacts: false,
    isOptedOutContacts: false,
    isUnreadContacts: true,
  },
  myconversations: {
    isShowAll: true,
    onlyMyConversations: true,
    isSpam: false,
    isInvalidContacts: false,
    isOptedOutContacts: false,
    isUnreadContacts: false,
  },
  spam: {
    isShowAll: true,
    onlyMyConversations: false,
    isSpam: true,
    isInvalidContacts: false,
    isOptedOutContacts: false,
    isUnreadContacts: false,
  },
  invalidcontacts: {
    isShowAll: true,
    onlyMyConversations: false,
    isSpam: false,
    isInvalidContacts: true,
    isOptedOutContacts: false,
    isUnreadContacts: false,
  },
  optedoutcontacts: {
    isShowAll: true,
    onlyMyConversations: false,
    isSpam: false,
    isInvalidContacts: false,
    isOptedOutContacts: true,
    isUnreadContacts: false,
  },
} as const;

export type FilterType = keyof typeof filterPresets;
